import script from "./PosttreatmentRetestDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PosttreatmentRetestDetail.vue?vue&type=script&setup=true&lang=js"

import "./PosttreatmentRetestDetail.vue?vue&type=style&index=0&id=72e2b45e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e2b45e"]])

export default __exports__